import { apiRequest } from "./api";
import type { CancelledGigHistoryItemResponse } from "../types/cancelledGigTypes";
import type {
  TeenDashboardCompletedGigItemResponse,
  TeenDashboardSnapshotResponse,
} from "../types/teenDashboardTypes";
import type { ResolvedGigIssueItemResponse } from "../types/resolvedIssueTypes";

export const teenDashboardApi = {
  getSnapshot(): Promise<TeenDashboardSnapshotResponse> {
    return apiRequest<TeenDashboardSnapshotResponse>("/api/teen/dashboard/snapshot", {
      method: "GET",
    });
  },

  listCompletedGigs(): Promise<TeenDashboardCompletedGigItemResponse[]> {
    return apiRequest<TeenDashboardCompletedGigItemResponse[]>("/api/teen/completed-gigs", {
      method: "GET",
    });
  },

  listResolvedIssues(): Promise<ResolvedGigIssueItemResponse[]> {
    return apiRequest<ResolvedGigIssueItemResponse[]>("/api/teen/resolved-issues", {
      method: "GET",
    });
  },

  listCancelledGigs(): Promise<CancelledGigHistoryItemResponse[]> {
    return apiRequest<CancelledGigHistoryItemResponse[]>("/api/teen/cancelled-gigs", {
      method: "GET",
    });
  },
};
